import { useState } from "react";
import { getBatch, getSortedCollection } from "sprint-common-web";

import { DeliveryBucketItem } from "./DeliveryBucketItem";
import { DeliveryBucketListingFilters } from "./useDeliveryBucketListingFilters";

export const useDeliveryBucketListing = () => {
    const [items, setItems] = useState<DeliveryBucketItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const saveData = (deliveryBucketItems: DeliveryBucketItem[], filters: DeliveryBucketListingFilters): void => {
        const sortedItems = getSortedCollection(deliveryBucketItems, filters.sortBy, filters.sortOrder);
        const itemsToDisplay = getBatch(sortedItems, filters.pageSize, filters.page);
        setTotalItems(sortedItems.length);
        setItems(itemsToDisplay);
    };

    return {
        items,
        totalItems,
        saveData
    };
};
